import themes from 'themes'
import {
  PGA_COACH_ERROR_BG,
  PGA_COACH_ERROR_TEXT,
  PGA_COACH_NAVY,
  PGA_COACH_PROMO_BG,
} from 'lib/styles/pga-coach-pill-colors'
import {
  SCHEDULE_EVENT_COLORS,
  SCHEDULE_EVENT_TYPES,
  SCHEDULE_LESSON_PACK_COLOR,
} from './todays-schedule/schedule-event-colors'

/** themes.js pgaCoach palette.blue.main — Reply button, links, unread dots */
export const PGA_COACH_ACTION_BLUE = themes.pgaCoach.palette.blue.main

/** themes.js common palette.sidebar.activeBg — dashboard icon circles, neutral chips */
export const DASHBOARD_SURFACE_MUTED = themes.common.palette.sidebar.activeBg

/** themes.js common palette.sidebar.itemText — dashboard headings and chip text */
export const DASHBOARD_BODY_TEXT = themes.common.palette.sidebar.itemText

/** benchmarks/styles.js scaleTick — median ticks and neutral benchmark markers */
export const BENCHMARK_SCALE_TICK = '#C5D0D6'

/** Coach marker on benchmark detail scale */
export const BENCHMARK_COACH_MARKER = PGA_COACH_NAVY

/** requirements/status-chip success + profile-overview promotionStatusPromoted */
export const PGA_COACH_SUCCESS_BG = '#BEF1BB'
export const PGA_COACH_SUCCESS_TEXT = '#00210B'

/** schedule-event-colors GROUP_EVENT badge — top-10 benchmark chips */
export const PGA_COACH_GROUP_BADGE_BG = '#F1E9D8'
export const PGA_COACH_GROUP_BADGE_TEXT = '#5C4922'

/** schedule-event-colors GROUP_EVENT accent — top-10 benchmark bar fill */
export const PGA_COACH_GROUP_EVENT_COLOR =
  SCHEDULE_EVENT_COLORS[SCHEDULE_EVENT_TYPES.GROUP_EVENT]

/** schedule-event-colors PRIVATE accent — booking mix private segment */
export const PGA_COACH_PRIVATE_LESSON_COLOR =
  SCHEDULE_EVENT_COLORS[SCHEDULE_EVENT_TYPES.PRIVATE]

/** Weekly revenue line, gradient, and dots — same token as coach action blue */
export const WEEKLY_REVENUE_CHART_COLOR = PGA_COACH_ACTION_BLUE

export const BOOKING_MIX_SEGMENT_COLORS = {
  private: PGA_COACH_PRIVATE_LESSON_COLOR,
  group: PGA_COACH_GROUP_EVENT_COLOR,
  packages: SCHEDULE_LESSON_PACK_COLOR,
}

export const BENCHMARK_PALETTE = {
  neutral: {
    track: DASHBOARD_SURFACE_MUTED,
    marker: BENCHMARK_SCALE_TICK,
  },
  success: {
    chipBackground: PGA_COACH_SUCCESS_BG,
    chipText: PGA_COACH_SUCCESS_TEXT,
    scaleFill: '#5CC268',
  },
  info: {
    chipBackground: PGA_COACH_PROMO_BG,
    chipText: PGA_COACH_NAVY,
    scaleFill: WEEKLY_REVENUE_CHART_COLOR,
  },
  danger: {
    chipBackground: PGA_COACH_ERROR_BG,
    chipText: PGA_COACH_ERROR_TEXT,
    scaleFill: '#E57373',
  },
  top10: {
    chipBackground: PGA_COACH_GROUP_BADGE_BG,
    chipText: PGA_COACH_GROUP_BADGE_TEXT,
    barFill: PGA_COACH_GROUP_EVENT_COLOR,
  },
}

export {
  PGA_COACH_ERROR_BG,
  PGA_COACH_ERROR_TEXT,
  PGA_COACH_NAVY,
  PGA_COACH_PROMO_BG,
}
